<div class="modal-header">
    <div class="d-flex justify-content-between align-items-center w-100">
        <div class="d-flex align-items-center">
          <img src="./assets/images/ls-logo.png" class="rounded me-2 logo" alt="ls">
          <h4 class="m-0 text-black text-{{headerAlign}}">{{header || 'Ledgersync'}}</h4>
        </div>
      <button (click)="close()" type="button" class="btn-close" aria-label="Close"></button>
    </div>
</div>
<div class="modal-body text-black d-flex flex-column gap-2 align-items-center justify-content-center">
    <div *ngIf="message" class="message">{{message}}</div>
    <div *ngIf="html" [innerHTML]="html"></div>
    <youtube-player class="yt-player w-100 d-flex justify-content-center"
                    *ngIf="videoId" [videoId]="videoId"></youtube-player>
    <div *ngIf="dontShow.dontShowAgain" class="text-center">
        <mat-checkbox [(ngModel)]="dsValue" (change)="updateDontShow()">
            <span class="f-size-11em">Don't show again</span>
        </mat-checkbox>
    </div>
</div>
<div class="modal-footer" *ngIf="footer">
    <app-button *ngFor="let button of buttons" [variant]="button.variant || 'primary'" (click)="button.callback(modalRef)"
    >{{button.caption}}</app-button>
</div>